import { Injectable } from '@angular/core';
import { Headers, RequestOptions, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../environments/environment';

//@Injectable()
export class HttpHeader {
    
    constructor() { }

    public Http_Header_Request_OptionsTest(): RequestOptions {
        let header = new Headers(
            {
                'Content-Type': 'application/json',
                'DBName': window.location.hostname,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
            }
        );

        return new RequestOptions({ headers: header });
    }
}

//import { Headers, RequestOptions } from '@angular/http';

export const header = new Headers(
    {
        'Content-Type': 'application/json',
        'DBName': window.location.hostname,
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
    }

);
export const Http_Header_Request_Options = new RequestOptions({ headers: header });


// WEBPACK FOOTER //
// ./SignClient/app/core/httpheader.ts